import './App.css';
import '../i18n/config';
import { AppProviders } from '../providers';
import { AppRouter } from '../routing';
import { Toaster } from '@/shared/infra/ui/components/ui/sonner';
import SessionBootstrap from '@/shared/infra/auth/SessionBootstrap';

function App() {
  return (
    <AppProviders>
      <Toaster position="top-right" />
      {/* Establish who the session cookie belongs to before any route can decide to redirect. */}
      <SessionBootstrap>
        <AppRouter />
      </SessionBootstrap>
    </AppProviders>
  );
}

export default App;
